import * as types from '../actions';

export default function(state:any = [], action:any) {
  const response = action.response;
  if (action.type === types.LOADING) {
    return { ...state, response };
  } else {
    return state;
  }
};